<template>
    <div>
        <!--              :confirm-loading="confirmLoading"-->
        <a-modal
                title="修改密码"
                :visible="visible"
                @ok="handleOk"
                @cancel="handleCancel"
        >

            <a-form-model ref="ruleForm" :model="form" :rules="rules"   :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }" @submit="handleOk">
                <a-form-model-item
                        ref="password"
                        label="原始密码"
                        prop="password"
                        :extra="formErr.password"
                        :validateStatus='!formErr.password||formErr.password==""?"":"error"'
                >
                    <a-input type="password"
                             v-model="form.password"
                            @change="(e) => { formErr.password=''}"
                            @blur="(e) => {  form.password = e.target.value.trim() }"
                    />
                </a-form-model-item>
                <a-form-model-item
                        ref="newpassword"
                        label="新密码"
                        prop="newpassword"
                        :extra="formErr.newpassword"
                        :validateStatus='!formErr.newpassword||formErr.newpassword==""?"":"error"'
                >
                    <a-input type="password"
                             v-model="form.newpassword"
                             @change="(e) => { formErr.newpassword=''}"
                             @blur="(e) => {  form.newpassword = e.target.value.trim() }"
                    />
                </a-form-model-item>
                <a-form-model-item
                        ref=" repassword"
                        label="重复新密码"
                        prop="repassword"
                        :extra="formErr.repassword"
                        :validateStatus='!formErr.repassword||formErr.repassword==""?"":"error"'
                >
                    <a-input type="password"
                             v-model="form.repassword"
                             @change="(e) => { formErr.repassword=''}"
                             @blur="(e) => {  form.repassword = e.target.value.trim() }"
                    />
                </a-form-model-item>
            </a-form-model>
        </a-modal></div>
</template>

<script>
    import axios from "../../../utils/request";
    export default {
        name: "changePassword",
        props:{
            visible: Boolean
        },
        data() {
            let validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('Please input the password'));
                } else {
                    if (this.ruleForm.checkPass !== '') {
                        this.$refs.ruleForm.validateField('checkPass');
                    }
                    callback();
                }
            };
            let checkPassword=(rule, value, callback)=> {
                if(this.form.newpassword!=value){
                    callback(new Error('两次输入密码不一致'))
                }else{   callback();}

            }
            return {
                formErr: { password: "", repassword: "",newpassword:"" },
                form: { password: "", repassword: "",newpassword:"" },
                confirmLoading: false,
                formLayout: 'horizontal',

                rules: {
                    password: [{required: true, message: "请输入原始密码 ", trigger: "blur"}, { whitespace: true, message: "请输入原始密码 " } ],
                    newpassword : [{required: true, message: "请输入新密码 ", trigger: "blur"}, {  whitespace: true, message: "请输入新密码 " }],
                    repassword: [{required: true, message: "请输入重复新密码 ", trigger: "blur"},{validator: checkPassword , trigger: "blur"  }, {  whitespace: true, message: "请输入重复新密码 " },

                        ],
                },
            };
        },
        methods: {
            handleOk(e) {
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        axios.post("/admin/AUser/passwordEditPost", {
                                ...this.form
                        }).then(res=>{
                            if(res.data.code==200){
                            this.handleCancel()
                                this.$message.success(res.data.msg,1.5)
                                }
                            res.data.msg.map((item, index) => {
                                this.formErr[item.field] = item.msg
                            })
                        })
                    }
                });
            },
            handleCancel(e) {
                this.$refs.ruleForm.resetFields();
                this.$emit("changVisible",false);
            },
        },
    }
</script>

<style scoped>

</style>
